var _rect, _path, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricboardMike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.2332,
    y: 4.6668,
    width: 4.2,
    height: 11.2,
    rx: 2.1,
    fill: "#46474C",
    stroke: "#46474C",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9334 13.3003C19.9334 16.3931 17.4262 18.9003 14.3334 18.9003C11.2406 18.9003 8.7334 16.3931 8.7334 13.3003",
    stroke: "#46474C",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9835,
    y: 18.5502,
    width: 0.7,
    height: 5.13333,
    rx: 0.35,
    stroke: "#46474C",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24019 20.7455C5.08544 20.9002 5.05373 21.1085 5.08304 21.2837C5.11248 21.4596 5.20477 21.6293 5.33963 21.7641C5.47448 21.899 5.64412 21.9913 5.82006 22.0207C5.99528 22.05 6.20355 22.0183 6.3583 21.8636L21.73 6.49188C21.8847 6.33713 21.9164 6.12886 21.8871 5.95364C21.8577 5.7777 21.7654 5.60806 21.6306 5.47321C21.4957 5.33835 21.3261 5.24606 21.1501 5.21663C20.9749 5.18731 20.7666 5.21902 20.6119 5.37377L5.24019 20.7455Z",
    fill: "#46474C",
    stroke: "#F7F7F8",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricboardMike);
export default __webpack_public_path__ + "static/media/electricboard-mike.452540cf9ed6ca94e3d80a6267004205.svg";
export { ForwardRef as ReactComponent };